
import Datetime from 'vux/src/components/datetime/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Countup from 'vux/src/components/countup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'


export default {
components: {
Datetime,
PopupPicker,
Countup,
Popup,Group,PopupHeader,XButton,Radio
},
directives: {
TransferDom
},
data() {
return {
popUp:false,
codeShow:false,
showDates:false,
pickerStatus:false,
dateStatus:false,
index:0,
account:'',
password:'',
datas:{
count_back: 0,
back_clothe: 0,
back_shoe: 0,
back_annex: 0,
count_in: 0,
clothe_in: 0,
shoe_in: 0,
annex_in: 0,
count_out: 0,
clothe_out: 0,
shoe_out: 0,
annex_out: 0,
count_wait: 0,
shoe_wait: 0,
clothe_wait: 0,
annex_wait: 0,
},
startDate:'',
endDate:'',
factoryTitle:'请选择',
factoryId:1,
factory:[],
info:[],
}
},
created(){
if(!this.$func.getLocal('factory_token')){
this.$router.push({path:'/factoryData'});
}else{
this.getFactory();
this.setDate();
setTimeout(() => {
this.getData();
}, 300);
}
},
methods: {
setDate() {
this.startDate = this.$func.getCurrentDate();
},
showDate(e){
this.index = e;
this.dateStatus = true;
},
previous(){
this.startDate = this.$func.modifyDate(this.startDate,-1);
this.getData();
},
next(){
this.startDate = this.$func.modifyDate(this.startDate,1);
this.getData();
},
barOrder(code){
this.$router.push({name:'barOrder',params:{code:code}})
},
showCode(item){
this.info = item;
this.popUp = true;
this.codeShow = true;
},
closePop(){
this.popUp = false;
this.codeShow = false;
},
dateChange(e){
if(this.index > 0){
this.endDate = e;
}else{
this.startDate = e;
}
setTimeout(() => {
this.getData();
}, 300);
},
reset(){
this.factoryId = this.factory[0].key;
this.factoryTitle = this.factory[0].value;
this.setDate();
setTimeout(() => {
this.getData();
}, 300);
},
onChange (value) {
console.log(value);
this.factoryId = value;
let that = this;
this.factory.forEach((item,index)=>{
if(item.key == value){
that.factoryTitle = item.value;
return;
}
})
},
getData() {
this.$func.startLoading();
this.$api.getFactoryData({date:this.startDate,id:this.factoryId}).then((res)=>{
if(res){
this.datas = res.data;
this.pickerStatus = false;
this.$func.endLoading();
}
})
},
getFactory() {
let that = this;
this.$api.getFactorys({}).then((res)=>{
if(res){
that.factory = res.data.factory;
that.factoryId = that.factory[0].key;
that.factoryTitle = that.factory[0].value;
}
})
},

}
}



// WEBPACK FOOTER //
// ./src/pages/getFactoryData.vue